/**
 * エリア1件に属するPointの集まり
 *
 * エリアの定義と、属するPointと、絞り込みを通ったPointのidを持つ
 */

export class AreaMembership {
  readonly area: AreaLabelArea

  private _points: Point[] = []

  /**
   * 属するPointのid
   *
   * 絞り込みを通ったidとの突き合わせに使うので、idだけの集合も持つ
   */
  private _pointIds = new Set<number>()

  /**
   * 直近の絞り込みを通ったPointのid
   *
   * ラベルに表示する件数はこの大きさで足りるので、Pointの配列は持たない
   */
  private _shownIds = new Set<number>()

  /**
   * @param area このエリア、ラベルの名称と座標をここから読む
   */
  constructor(area: AreaLabelArea) {
    this.area = area
  }

  /**
   * 属するPointとして加える
   *
   * どのPointを加えるかは areaGrouping が振り分ける
   */
  add(point: Point) {
    this._points.push(point)
    this._pointIds.add(point.id)
  }

  /**
   * エリアに属するPoint
   *
   * 絞り込みは反映しない
   * 外から増減させないよう読み取り専用で渡す
   */
  get points(): readonly Point[] {
    return this._points
  }

  /**
   * 絞り込みを通ったidを取り直して保持する
   *
   * @param shownIds 絞り込みを通ったPointのid、絞り込みの判定は呼び出し側が持つ
   *   shownIds には全エリア分のidが渡るので、このエリアに属するものだけを残す
   */
  updateShown(shownIds: Set<number>) {
    // Set.prototype.intersection は対応していないブラウザが残るので、走査して積集合を作る
    const matched = new Set<number>()

    this._pointIds.forEach(id => {
      if (shownIds.has(id)) {
        matched.add(id)
      }
    })

    this._shownIds = matched
  }

  /**
   * 直近の絞り込みを通ったPointの件数
   */
  get shownCount(): number {
    return this._shownIds.size
  }

  /**
   * 絞り込みを通ったPointが無いか
   *
   * 0件のラベルを隠すかの判断に使う
   * 属するPointが無いこととは別で、絞り込みで残らなかった場合も含む
   */
  get isEmpty(): boolean {
    return this._shownIds.size === 0
  }

  /**
   * 直近の絞り込みを通ったPoint
   *
   * 読むたびに組み立てるので、ラベルのクリックのような稀な経路から呼ぶ
   * 並びは属するPointの順を保つ
   */
  getShownPoints(): Point[] {
    return this._points.filter(point => this._shownIds.has(point.id))
  }
}
